import PropTypes from "prop-types";
import * as React from "react";
import { addonPropType } from "../../domain";
import SexyButton from "../../theme/SexyButton";
import OrderAddonBadge, { withCancelled } from "../Addons/AddonBadge";
import PurchaseModal, { PURCHASE_TYPES } from "../PurchaseModal";

export default function PrioritySigningAddon({
  autographPurchaseId,
  isCancelled,
  addon,
  has,
  user,
  onPurchase,
  canPurchase,
  hasPurchased,
}) {
  const purchaseProps = React.useMemo(
    () => ({
      type: PURCHASE_TYPES.ADDON_PURCHASE,
      name: addon.name,
      title: addon.title,
      description: addon.description,
      amount: addon.price.value * 100,
      autographPurchaseId,
    }),
    [addon, autographPurchaseId],
  );

  const action = React.useMemo(() => {
    return withCancelled(isCancelled, () => {
      if (!has) {
        return (
          <PurchaseModal onPurchase={onPurchase} purchase={purchaseProps} />
        );
      }

      if (hasPurchased) {
        return (
          <SexyButton className="green" disabled>
            Purchased
          </SexyButton>
        );
      }

      if (user.isStreamilyFamilyMember) {
        return (
          <SexyButton className="green" disabled>
            Included with VIP
          </SexyButton>
        );
      }

      return null;
    });
  }, [
    onPurchase,
    purchaseProps,
    isCancelled,
    has,
    user.isStreamilyFamilyMember,
    hasPurchased,
  ]);

  return (
    <OrderAddonBadge
      title={addon.title}
      description={addon.description}
      icon={addon.icon}
      action={has || canPurchase ? action : null}
    />
  );
}

PrioritySigningAddon.propTypes = {
  addon: addonPropType.isRequired,
  autographPurchaseId: PropTypes.number.isRequired,
  isCancelled: PropTypes.bool,
  user: PropTypes.shape({
    isStreamilyFamilyMember: PropTypes.bool,
  }).isRequired,
  onPurchase: PropTypes.func,
  canPurchase: PropTypes.bool,
  has: PropTypes.bool.isRequired,
  hasPurchased: PropTypes.bool,
};
